var _getFactsheetValueFromItem = function getFactsheetValueFromItem(data) {
  if (!data) return null;
  if (typeof data === 'string') return data;
  if (Array.isArray(data)) return _getFactsheetValueFromItem(data[0]);
  return _getFactsheetValueFromItem((data == null ? void 0 : data.elements) || (data == null ? void 0 : data.value));
};
export { _getFactsheetValueFromItem as getFactsheetValueFromItem };
export var getFactsheetValueFromSlug = function getFactsheetValueFromSlug(factsheet, slug) {
  return _getFactsheetValueFromItem(factsheet == null ? void 0 : factsheet.find(function (i) {
    return i.slug === slug;
  }));
};